'use strict';

exports.__esModule = true;
var defaultBoxShadow = exports.defaultBoxShadow = '0px 2px 2px rgba(113, 114, 215, 0.34), 0px 0px 2px rgba(113, 114, 215, 0.22)';
var hoverBoxShadow = exports.hoverBoxShadow = defaultBoxShadow + ', inset 0 0 0 99em rgba(255,255,255,0.07)';
var activeBoxShadow = exports.activeBoxShadow = '0px 0px 8px rgba(113,114,215,0.32), inset 0 0 0 99em rgba(0,0,0,0.1)';
var linearGradient = exports.linearGradient = 'linear-gradient(23deg, #F7618B, #2A7AFF 140%)';
var radialGradient = exports.radialGradient = 'radial-gradient(circle at top left,#F7618B, #2A7AFF)';
var hoverLinearGradient = exports.hoverLinearGradient = 'linear-gradient(246.08deg, #F7618B -16.64%, #2A7AFF 113.5%)';
var activeLinearGradient = exports.activeLinearGradient = 'linear-gradient(0deg, rgba(16, 31, 45, 0.2), rgba(16, 31, 45, 0.2)), linear-gradient(246.08deg, #F7618B -16.64%, #2A7AFF 113.5%)';
var glow = exports.glow = '0px 14px 65px rgba(210, 102, 160, 0.7), 0px 4px 14px rgba(16, 33, 49, 0.6), 0px 8px 14px rgba(39, 64, 88, 0.4)';


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/sharedStyles.js
// module id = 6
// module chunks = 2